import IconTextButton from "../../../components/iconTextButton/IconTextButton";
import { CSVLink } from "react-csv"
import { IUsageSearchResultRowType } from "../../../types/usageTypes/IUsageGroupsSearchResult";
import { USAGE_SEARCH_RESULTS_VIEW, USAGERESULTTABLE_VIEW } from "../../../Consts";
import DropDownButtonDefaultView from "./DropDownButtonDefaultView";
import IRepertoireComponentDataItem from "../../../../redux/types/IRepertoireComponentDataItem";
import { IComponentView } from "../../../../redux/types/ComponentView";
import ITooltip from "../../../components/Tooltip/IToolTip";
import { IComponent } from "office-ui-fabric-react/lib/Foundation";
import { IComponentViewsPreference } from "../../../../redux/types/IComponentViewsPreference";
import { IComponentViewItemReduxStore, IComponentViewReduxStore } from "../../../../redux/types/ComponentViewReduxStore";
import React from "react";

export interface IUsageSearchToolBar {
    componentViews?: IComponentViewReduxStore;
    data?: IUsageSearchResultRowType[];
    getIconForExpandAll?: () => string;
    onClickExpandAll?: (rows: IUsageSearchResultRowType[]) => void;
    onClickSave?: () => void;
    showFieldsModal?: (componentFieldName: string) => void;
    hasChanges?: number[]
    settingsModalViewData?: IRepertoireComponentDataItem;
    setActiveComponentView?: (activeComponentView: any) => void;
    activeComponentView?: IComponentView;
    userIsConfigureComponentViewAdmin?: boolean;
    componentViewPreference?: IComponentViewsPreference;
}

const UsageSearchToolbar = (props: IUsageSearchToolBar) => {
    const { 
        data,
        getIconForExpandAll,
        onClickExpandAll,
        onClickSave,
        showFieldsModal,
        hasChanges,
        componentViews,
        settingsModalViewData,
        setActiveComponentView,
        activeComponentView,
        userIsConfigureComponentViewAdmin,
        componentViewPreference
    } = props;
    const [buttonComponentViews, setButtonComponentViews] = React.useState<IComponentView[] | undefined>(componentViews?.usageSearchResultsViews?.componentViews || []);

    React.useEffect(() => {
        if (componentViews?.usageSearchResultsViews?.componentViews) {
            setButtonComponentViews(componentViews.usageSearchResultsViews.componentViews);
        }
    }, [componentViews]);

    return (
        <div
            className="toolbarWrapper flexRow flexJustifyContentSpaceBetween"
            id={"toolbar"}
        >
            <div className="flexRow flexAlignItemsBaseLine">
                <CSVLink
                    filename={"UsageSearchResults.csv"}
                    data={data.map(({ matchesExpanded, ...keepAttrs }) => ({
                        ...keepAttrs,
                        title: keepAttrs.title?.replace(/"/g, '""')
                    }))}

                    className="btn"
                    enclosingCharacter={'"'}
                    delimiter={","}
                >
                    <IconTextButton
                        text="Export"
                        icon="icon ms-Icon ms-Icon--Download"
                    />
                </CSVLink>

                <div style={{paddingLeft:"6px", paddingRight:"6px"}}>
                    <IconTextButton text="Show All Matches" icon={"icon ms-Icon ".concat(getIconForExpandAll())}
                        onClick={() => onClickExpandAll(data)} />
                </div>

            </div>
            <div className="flexRow flexAlignItemsBaseLine">
                         <div style={{ paddingLeft: "6px", paddingTop: "10px"  }}>
                <DropDownButtonDefaultView
                isUserAdmin={userIsConfigureComponentViewAdmin}
                componentViewPreference={componentViewPreference}
                setActiveComponentView={setActiveComponentView}
                activeComponentView={activeComponentView}
                componentViews={buttonComponentViews}
                settingsModalViewData={settingsModalViewData}
                showFieldsModal={showFieldsModal}
                dropDownName={USAGE_SEARCH_RESULTS_VIEW}
                />
            </div>
           <div className="flexRow flexAlignItemsBaseLine">
             <div style={{ paddingLeft: "6px" }}>
               {userIsConfigureComponentViewAdmin ? <IconTextButton text="&nbsp;Configure Data Fields" icon={"ms-Icon ms-Icon--Settings"}
                    onClick={() => showFieldsModal ?
                        showFieldsModal(USAGERESULTTABLE_VIEW) : null} />
             : <ITooltip
                        tooltipContent={'User does not have access'}
                        showTooltip={true}
                    >
            <div style={{ paddingLeft: "6px" }}>
                <IconTextButton 
                text="&nbsp;Configure Data Fields" 
                icon={"ms-Icon ms-Icon--Settings"}
                disabled={true}/>
            </div>
             </ITooltip>}
          </div> 

    


            <div className="saveButton" >
                    <div className="saveButtonContainer btn-group" >
                        <button
                            title={"Save"}
                            aria-disabled={true}
                            className={(hasChanges.length > 0) ? "saveButton" : "disabledSaveButton"}
                            onClick={() => onClickSave()}
                            disabled={!(hasChanges.length > 0)}
                        >
                            <div className="saveButtonText">Save Changes</div>
                        </button>                 
                    </div>
                   
            </div>
            </div>
        </div>
        </div>
    );
}
export default UsageSearchToolbar